<div if.bind="account.emailOptInOpen" class="modal-overlay">
  <form class="login-modal profile-modal" submit.trigger="account.submitEmailOptIn(true)" click.trigger="$event.stopPropagation()">
    <h3 class="login-modal__title">Stay in the loop?</h3>
    <p class="profile-modal__subtitle">
      Toy Calendar can email ${account.userEmail} about new releases. Choose what you'd like &mdash;
      you can change this anytime in Notification settings.
    </p>

    <label class="profile-toggle">
      <span class="profile-toggle__text">
        <span class="profile-toggle__label">Daily digest</span>
        <span class="profile-toggle__hint">A summary of releases added in the last 24 hours.</span>
      </span>
      <input type="checkbox" class="profile-toggle__input" checked.bind="account.notificationPreferences.digestOptIn" disabled.bind="account.savingOptIn" />
    </label>

    <label class="profile-toggle">
      <span class="profile-toggle__text">
        <span class="profile-toggle__label">Saved-search alerts</span>
        <span class="profile-toggle__hint">Email me when new releases match a saved search I follow.</span>
      </span>
      <input type="checkbox" class="profile-toggle__input" checked.bind="account.notificationPreferences.notifySavedSearches" disabled.bind="account.savingOptIn" />
    </label>

    <label class="profile-toggle">
      <span class="profile-toggle__text">
        <span class="profile-toggle__label">Availability alerts</span>
        <span class="profile-toggle__hint">Email me when a release I follow becomes available.</span>
      </span>
      <input type="checkbox" class="profile-toggle__input" checked.bind="account.notificationPreferences.notifyAvailability" disabled.bind="account.savingOptIn" />
    </label>

    <div if.bind="account.optInError" class="login-error">${account.optInError}</div>
    <div class="login-actions">
      <button type="button" class="login-btn login-btn--secondary" click.trigger="account.submitEmailOptIn(false)" disabled.bind="account.savingOptIn">No thanks</button>
      <button type="submit" class="login-btn login-btn--primary" disabled.bind="account.savingOptIn">
        ${account.savingOptIn ? 'Saving…' : 'Email me'}
      </button>
    </div>
  </form>
</div>
